<template>
  <div class="popver-content">
    <div class="popvercheck">
      <el-checkbox-group v-model="checkList">
        <div v-for="item in allList" :key="item.value">
          <el-checkbox  :label="item.value" >
            <span style="cursor:text;user-select:text;">{{item.value}}</span>
          </el-checkbox>
        </div>
      </el-checkbox-group>
    </div>
    <div class="text-align-right top-default-margin">
      <el-button size="mini" @click="cancel">取消</el-button>
      <el-button size="mini" type="primary"  @click="save()">保存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name:"PopoverContentNew",
  props:['colData'],
  data() {
    return {
      checkList:[],
      allList:[],
    }
  },
  created() {
    var _this = this
    this.allList = JSON.parse(JSON.stringify(this.colData))
    this.allList.map(function(item){
      if(item.istrue == true){
        _this.checkList.push(item.value)
      }
    })
  },
  mounted(){

  },
  methods: {
    cancel(){
      this.$emit('done',{type:'cancel'})
    },
    save(){
      var _this = this
      this.allList.map(function(item){
        if(_this.checkList.indexOf(item.value)!=-1){
          _this.$set(item,'istrue',true)
        }else{
          _this.$set(item,'istrue',false)
        }
      })
      this.$emit('done',{type:'save',data:this.allList})
    },
  }
}
</script>

<style>

.popver-content .el-checkbox-group{
  position: relative;
  max-height: 250px;
  overflow-y: auto;
}
.popver-content .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #606266!important;
}
.popver-content .font-blue-clor{
  color: #1890ff;
}
.popver-content .el-checkbox, .el-checkbox__input{
  position: static;
}
.popver-content .right-icon{
  position: absolute;
  right: 0;
  color: #1890ff;
}
</style>



// WEBPACK FOOTER //
// src/components/PopoverContentNew.vue